import { render } from "./ContactUsInvestors.vue?vue&type=template&id=8fe93a42"
import script from "./ContactUsInvestors.vue?vue&type=script&lang=js"
export * from "./ContactUsInvestors.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__